// @flow
import React, {useEffect} from 'react';
import {useQuery} from '@apollo/react-hooks';
import {connect} from 'react-redux';
import {compose} from 'redux';
import RecentlyViewedCarousel from './RecentlyViewedCarousel';
import PropertyCarouselPlaceholder from '../PropertyCarousel/PropertyCarouselPlaceholder';
import withLingua from '../withLingua/withLingua';
import type {LinguaProps} from '../withLingua/withLingua';
import recentlyViewedActions from '../../actions/recentlyViewed';
import {
    recommendedListingsQuery,
    prepareResponse
} from './recommendedListingsQuery';
import {media} from '../../utils/breakpoints';
import {DESKTOP_BREAKPOINTS, MOBILE_BREAKPOINTS} from './breakpoints';
import {listingIds} from './listingIdsMock';

import './RecentlyViewedCarousel.less';

type OwnProps = {
    isLoading: boolean,
    isMobile: boolean,
    messages: any,
    pageIndex: number,
    fetchListingsSuccess: typeof recentlyViewedActions.fetchListingsSuccess
};

type Props = OwnProps & LinguaProps;

export const RecentlyViewedCarouselContainer = (props: Props) => {
    const {
        isLoading,
        isMobile,
        messages,
        pageIndex,
        fetchListingsSuccess
    } = props;
    const title = messages.recentlyViewed;
    const breakpoints = isMobile ? MOBILE_BREAKPOINTS : DESKTOP_BREAKPOINTS;

    // TODO: replace with real graphql query and variables
    const {loading, data, error} = useQuery(recommendedListingsQuery, {
        variables: {
            // pagination simulation on mock data
            listingIds: [listingIds[pageIndex]],
            size: 8
        }
    });
    useEffect(() => {
        if (loading || (!data && error)) {
            return;
        }

        const response = prepareResponse(data);
        fetchListingsSuccess(response);
    }, [data, error, loading, pageIndex, fetchListingsSuccess]);

    return isLoading ? (
        <PropertyCarouselPlaceholder
            isMobile={isMobile}
            title={title}
            breakpoints={breakpoints}
        />
    ) : (
        <RecentlyViewedCarousel
            {...props}
            title={title}
            breakpoints={breakpoints}
            isDataLoading={loading}
        />
    );
};

const mapStateToProps = (state) => {
    const {viewport, recentlyViewed} = state;
    const breakpoint = viewport.breakpoint;
    const isMobile = !media(breakpoint, {minWidth: 'SM_MIN'});

    return {
        isMobile,
        pageIndex: recentlyViewed.pageIndex
    };
};

const mapDispatchToProps = {
    fetchListingsSuccess: recentlyViewedActions.fetchListingsSuccess
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withLingua({
        namespace: 'traveler/search',
        category: 'messages'
    })
)(RecentlyViewedCarouselContainer);
